export const formatCurrency = (value = "") => {
  if (value === 0) return "";
  if (isNaN(parseFloat(value))) return value;
  if (!value) return "";

  
  if (typeof value !== "string") value = String(value); 
  {
    let str = value.split('.')[0];
    let comma = value.split('.')[1] === undefined ? "00" : value.split('.')[1];
    
    return str.match(/\d{1,3}(?=(\d{3})*$)/g).join(",") + "." + comma;
  }
};
